import { axiosFunction } from "../components/commonFunctions";
import { v2ReactURL } from "../utils/constant";

const useLocationApi = () => {
  // Get all country list...
  const getCountryList = async () => {
    const response = await axiosFunction(
      `${v2ReactURL}/location/country`,
      "GET"
    );
    if (response.data.status) {
      return response.data;
    } else {
      return [];
    }
  };

  // Get state List...
  const getStateList = async (countryCode : string) => {
    const response = await axiosFunction(
      `${v2ReactURL}/location/state/${countryCode}`,
      "GET"
    );
    if (response.data.status) {
      return response.data;
    } else {
      return [];
    }
  };

  const getCityList = async (cityCode : string) => {
    const response = await axiosFunction(
      `${v2ReactURL}/location/city/${cityCode}`,
      "GET"
    );
    if (response.data.status) {
      return response.data;
    } else {
      return [];
    }
  };

  return { getCountryList, getStateList, getCityList };
};

export default useLocationApi;
